module.exports = __webpack_public_path__ + "static/media/MKV.071d3649.svg";